<div>
	<ng-container *ngFor="let attr of attrFilters; let idx = index">
		<div *ngIf="attr.filter" class="filter-item">
			<div>{{colNameMap[attr.filter.col]}}</div>
			<i class="glyphicons glyphicons-remove" (click)="removeFilter(idx)"></i>
		</div>
	</ng-container>
</div>